<main class="mediumContainer">
    <div class="d-flex flex-row flex-space-between">
        <button (click)="back()" aria-label="Back" mat-icon-button matTooltip="Back">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
        <div class="d-flex flex-row justify-content-center">
            <h3 class="my-10">
                Hidden Media
            </h3>
        </div>
        <div></div>
    </div>
    <div class="profileContainer">
        <div class="media">
            @if (media) {
                <mat-card aria-label="View Picture" class="clickable imageCard">
                    <app-media-display (viewImage)="viewImage()" [file]="media" [small]="true"></app-media-display>
                    <mat-card-header (click)="viewImage()" class="pb-16">
                        <mat-card-title>{{ media.title }}</mat-card-title>
                        @if (media.description) {
                            <mat-card-subtitle>{{ media.description }}
                            </mat-card-subtitle>
                        }
                    </mat-card-header>
                </mat-card>
            }
            <br/>
            <mat-card>
                <mat-card-header class="flex-space-between">
                    <mat-card-title>Options</mat-card-title>
                </mat-card-header>
                <mat-card-actions class="flex-row flex-space-around">
                    <button (click)="unhide()" color="primary" mat-raised-button>
                        {{ media?.hidden_status === 'approval' ? 'Approve' : 'Un-hide' }}
                    </button>
                    @if (this.user && this.user.role.role_type == 'admin') {
                        <button (click)="delete()" color="warn"
                                mat-raised-button>Delete
                        </button>
                    }
                    @if (media) {
                        <button (click)="moveMedia()" color="primary" mat-raised-button>Move</button>
                    }
                </mat-card-actions>
            </mat-card>
        </div>
        @if (media) {
            <div class="d-flex flex-col gap-15 flex-grow details">
                <mat-card>
                    <mat-card-header class="flex-space-between">
                        <mat-card-title>Details</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        @if (this.timelineId) {
                            <p><b>Memory Box</b>:
                                <a [routerLink]="['/timeline', timelineId]">View Memory Box</a>
                            </p>
                        }
                        <p><b>Upload Date</b>: {{ media.created_date | date }}</p>
                        @if (media.user) {
                            <p><b>Uploader</b>: <a
                                    [routerLink]="['/user', media.user.id]">{{ media.user | nameDisplay }}</a></p>
                        }
                        @if (this.album) {
                            <p><b>Album Title</b>: {{ this.album.title }}</p>
                            <p><b>Album Description</b>: {{ this.album.description }}</p>
                        }
                        @if (media.hidden) {
                            <form [formGroup]="hiddenForm" class="flex-col mt-10">
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>Category:</mat-label>
                                    <select formControlName="hidden_status" matNativeControl>
                                        <option [value]="'hidden'">Hidden</option>
                                        <option [value]="'approval'">Awaiting Approval</option>
                                        <option [value]="'flagged'">Flagged</option>
                                    </select>
                                </mat-form-field>
                            </form>
                        }
                    </mat-card-content>
                    @if (media.hidden) {
                        <mat-card-actions class="flex-row flex-space-around">
                            <button (click)="patchMedia()" [disabled]="hiddenForm.invalid || loading" color="accent"
                                    mat-raised-button>
                                Save
                                @if (loading) {
                                    <mat-icon>
                                        <mat-spinner color="primary"></mat-spinner>
                                    </mat-icon>
                                }
                            </button>
                        </mat-card-actions>
                    }
                </mat-card>
            </div>
        }
        <div class="chat">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>
                        <h4 class="mt-0 mb-10"> Hidden Media Notes</h4>
                    </mat-card-title>
                </mat-card-header>
                <div #chatContent class="chatContent" id="chatContent">

                    @for (message of this.notes; track message) {
                        <div class="d-flex flex-row mb-10 gap-25">
                            @if (message.user.id !== user.id && user) {
                                @if (user.role.can_access_profiles) {
                                    <button (click)="viewProfile(message.user.id)"
                                            [attr.aria-label]="'View profile of ' + (message.user | nameDisplay)"
                                            class="avatarAction d-flex userPicContainer" type="button">
                                        @if (message.user.thumbnail || message.user.photo) {
                                            <img [alt]="message.user | nameDisplay"
                                                 [matTooltip]="'View ' +  (message.user | nameDisplay) + '\'s Profile'"
                                                 [src]="message.user.thumbnail || message.user.photo || 'assets/images/blankProfile.png'"
                                                 class="userPic" fetchPriority="low"
                                                 loading="lazy">
                                        }
                                        @if (!message.user.thumbnail && !message.user.photo) {
                                            <p class="initial m-10">
                                                {{ message.user.first_name | slice: 0 : 1 }} {{ message.user.last_name | slice: 0 : 1 }}
                                            </p>
                                        }
                                    </button>
                                } @else {
                                    <div class="d-flex userPicContainer">
                                        @if (message.user.thumbnail || message.user.photo) {
                                            <img [alt]="message.user | nameDisplay"
                                                 [matTooltip]="(message.user | nameDisplay) + '\'s Profile Picture'"
                                                 [src]="message.user.thumbnail || message.user.photo || 'assets/images/blankProfile.png'"
                                                 class="userPic" fetchPriority="low"
                                                 loading="lazy">
                                        }
                                        @if (!message.user.thumbnail && !message.user.photo) {
                                            <p class="initial m-10">
                                                {{ message.user.first_name | slice: 0 : 1 }} {{ message.user.last_name | slice: 0 : 1 }}
                                            </p>
                                        }
                                    </div>
                                }
                            }
                            <div class="d-flex flex-grow flex-col mw-95">
                                <div class="talk-bubble p-10">
                                    <strong class="primaryContrast f-14">{{ message.user| nameDisplay }}</strong>
                                    <p class="m-0">{{ message.text }}</p>
                                    @if (receivedToday(message.created_at)) {
                                        <small class="extraSmall m-5">{{ message.created_at|date:"HH:mm" }}</small>
                                    }
                                    @if (!receivedToday(message.created_at)) {
                                        <small class="extraSmall m-5">{{ message.created_at|date:"dd/MM/yyyy" }}</small>
                                    }
                                </div>
                            </div>
                            @if (message.user.id == user.id) {
                                <div class="d-flex userPicContainer">
                                    @if (message.user.thumbnail || message.user.photo) {
                                        <img [alt]="message.user| nameDisplay"
                                             [matTooltip]="message.user | nameDisplay"
                                             [src]="message.user.photo || 'assets/images/blankProfile.png'"
                                             class="userPic" fetchPriority="low"
                                             loading="lazy">
                                    }
                                    @if (!message.user.thumbnail && !message.user.photo) {
                                        <p class="initial m-10">
                                            {{ message.user.first_name | slice: 0 : 1 }} {{ message.user.last_name | slice: 0 : 1 }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <mat-card-actions class="mb-0">
                    @if (reLoading) {
                        <mat-card-footer>
                            <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
                        </mat-card-footer>
                    }
                    <form [formGroup]="messageForm" class="d-flex flex-row w-100 gap10">
                        <div class="flex-auto">
                            <mat-form-field appearance="outline" class="w-100"
                                            color="primary">
                                 <textarea #message aria-label="Comment content"
                                           formControlName="message" matInput maxlength="400"
                                           name="message"></textarea>
                                <mat-hint align="end">{{ message?.value?.length }} / 400</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="flex-col">
                            <app-emoji-menu [form]="messageForm" [input]="'message'" matSuffix></app-emoji-menu>
                            <button (click)="addNote()" (keyup.enter)="addNote()"
                                    [disabled]="message && message.value && this.reLoading"
                                    aria-label="Submit Comment"
                                    class="ms-auto col-12 text-right"
                                    color="primary" mat-icon-button>
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </button>
                        </div>
                    </form>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</main>
